<template>
  <div
    :class="{ selected: batch.loteId === selectedBatch }"
    class="row p-3 mt-2 shadow-sm bg-white"
  >
    <div class="col-11">
      <div class="row justify-content-center">
        <div class="col-2 text-center text-primary">
          <div
            data-cy="file-number"
            v-tooltip="'Número de folio'"
            :class="{ 'text-success': wasCopied }"
            class="cursor-pointer"
          >
            {{ batch.folio }}
          </div>
          <b-form-checkbox
            v-if="!onlyRead"
            v-model="batch.selected"
            @change="selectElement"
          />
        </div>
        <div
          class="col-5"
          v-tooltip="'Descripción de lote'"
        >
          <read-more
            :text="batch.descripcionLote"
          />
        </div>
        <div class="col-5">
          <vs-chip
            class="mr-4"
            color="#7d84ad"
            v-tooltip="'Monto Mínimo'"
            v-if="batch.montoMinimo"
          >
            <vs-avatar icon="monetization_on" />
            {{ batch.montoMinimo | amount}}
          </vs-chip>
          <vs-avatar
            v-else
            color="danger"
            icon="error"
            size="small"
            v-tooltip="'Sin monto mínimo'"
          />
          <vs-chip color="#ff9800" class="mr-4" v-tooltip="'Fecha de Emisión'">
            <vs-avatar icon="date_range" />
            {{ batch.fechaCreacion | dateFormat}}
          </vs-chip>
        </div>
      </div>
    </div>
    <div class="col-1 d-flex justify-center">
      <slot name="actions" v-bind:batch="batch">
        <div class="d-flex justify-content-center align-items-center">
          <b-button
            v-has-permission="'ED197'"
            variant="secondary"
            class="btn-icon rounded-circle mr-2"
            size="sm"
            v-if="!onlyRead"
            data-cy="open-edit-batch"
            v-b-tooltip="'Editar monto mínimo'"
            v-on:click.stop.prevent="openModalEditBatch"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            v-has-permission="'ED198'"
            variant="danger"
            class="btn-icon rounded-circle"
            size="sm"
            v-if="!onlyRead"
            data-cy="delete-auction-batch"
            v-b-tooltip="'Quitar lote de subasta'"
            v-on:click.stop.prevent="handleDeleteAuctionBatch(batch)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </slot>
    </div>
    <b-modal
      ref="edit-batch"
      :title="`Detalles del Lote Nº ${batch.folio}`"
      hide-footer
      no-close-on-backdrop
    >
      <div class="col-12 mt-3">
        <div>
          <strong>Monto mínimo actual</strong>
          <div class="ml-3">
            {{ batch.montoMinimo | amount }}
          </div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <div>
          <strong>Nuevo monto mínimo</strong>
          <b-form data-vv-scope="batch-form">
            <b-form-group>
              <b-form-input
                name="number"
                v-model="newMinimunAmount"
                v-validate="'required'"
                data-vv-as="Monto mínimo"
                :state="errors.has('batch-form.number') ? false : null"
              />
              <b-form-invalid-feedback>
                {{ errors.first('batch-form.number') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form>
        </div>
        <div class="text-right">
          <b-button
            class="badge-glow ml-3 mb-5"
            variant="primary"
            v-has-permission="'ED199'"
            data-cy="attempt-edit-batch"
            size="sm"
            :disabled="disableEditBatchButton"
            @click="attemptEditBatch()"
          >
            Guardar
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import { batchesStates } from '@/febos/aduanas/batches/views/utils/constants';
import { attemptUpdateBatchEspecificData } from '@/febos/aduanas/batches/store/actions';
import ReadMore from '@/components/info-display/ReadMore';

export default {
  mixins: [CopyToClipboard],
  components: { ReadMore },
  data() {
    return {
      batchesStates,
      newMinimunAmount: this.batch.montoMinimo,
      disableEditBatchButton: false
    };
  },
  props: [
    'batch',
    'onlyRead'
  ],
  computed: {
    ...mapGetters('batches', [
      'selectedBatch'
    ]),
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('batches', {
      attemptUpdateBatchEspecificData: attemptUpdateBatchEspecificData.name
    }),
    selectElement() {
      if (this.batch.selected) {
        this.$emit('select-check-batch', this.batch);
        return;
      }
      this.$emit('unselect-check-batch', this.batch);
    },
    handleDeleteAuctionBatch() {
      this.$emit('handle-delete-auction-batch', this.batch);
    },
    openModalEditBatch() {
      this.disableEditBatchButton = false;
      this.$refs['edit-batch'].show();
    },
    async attemptEditBatch() {
      const result = await this.$validator.validateAll('batch-form');
      if (!result) {
        return;
      }
      this.disableEditBatchButton = true;
      const newBatch = {
        loteId: this.batch.loteId,
        montoMinimo: parseInt(this.newMinimunAmount, 10)
      };
      await this.attemptUpdateBatchEspecificData(newBatch);
      this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha actualizado correctamente el lote',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
      this.batch.montoMinimo = parseInt(this.newMinimunAmount, 10);
      await this.$validator.reset();
      this.$refs['edit-batch'].hide();
    }
  }
};
</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}
</style>
